<template>
  <div class="login-wrapper">
    <div class="login-box" style="margin: 0 auto">
      <div class="needs-validation" id="validated-form">
        <h3 class="login-box__title">ÜYE GİRİŞİ</h3>
        <VueButton3
          v-if="showErrorMessage"
          class="red fw shadow-none login-box__submit mycursor1"
          title="Lütfen bilgilerinizi kontrol edin!"
        />
        <v-input ref="input1" placeholder="E-Posta Adresi" v-model="email" />
        <label for="password" v-if="falseEmail" class="myValidationText"
          >Geçersiz e-posta formatı!</label
        >
        <label for="password" v-if="emptyEmail" class="myValidationText"
          >Bu kısım boş geçilemez!</label
        >
        <span
          class="text-danger"
          v-if="validationErrors.email"
          v-text="validationErrors.email"
        ></span>
        <v-input
          ref="input2"
          placeholder="Şifre"
          type="password"
          v-model="password"
        />
        <label for="password" v-if="emptyPassword" class="myValidationText"
          >Bu kısım boş geçilemez!</label
        >
        <router-link class="password-forget" to="/sifremi-unuttum">
          Şifremi Unuttum</router-link
        >
        {{ error }}
        <v-button
          class="green fw shadow-none login-box__submit"
          @click.native="login"
          title="GİRİŞ YAP"
        />
        <div class="or">
          <p class="or__title">VEYA</p>
        </div>
        <v-button
          @click.native="gitKayit"
          class="gray fw shadow-none login-box__submit"
          title="ÜYE OL"
        />
      </div>
      <div class="login-box__bottom">
        <!--       <p class="login-box__bottom-text">Yurtlarburada.com'da yeni misiniz?</p>

      <router-link to="/kayit-ol" class="button button--more color-light-green" style="color: #5567ab !important;">
        <span class="button__wrp"><span class="button__txt">
              ŞİMDİ KAYDOLUN
        </span>
          <span class="button__icon"><svg class="icon">
            <use xlink:href="/icon/icons.svg#icon-arrow-long-right"></use></svg></span></span></router-link> -->

        <div>
          <router-link
            to="/yurt-girisi"
            class="button button--more color-light-green"
            ><span class="button__wrp">
              <span class="button__txt">
                YURT GİRİŞİ
              </span>
              <span class="button__icon">
                <svg class="icon">
                  <use
                    xlink:href="/icon/icons.svg#icon-arrow-long-right"
                  ></use></svg></span></span
          ></router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueButton3 from '@/components/VueButton3'
import { SET_TOKEN, SET_USER_INFO } from '@/store/mutations.type'
import axios from 'axios'
export default {
  name: 'Login',
  components: {
    VueButton3
  },
  metaInfo() {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Üye Girişi',
      link: [
        { rel: 'canonical', href: window.location.origin + '/uye-girisi/' }
      ]
    }
  },
  data: function() {
    return {
      faculties: [],
      falseEmail: false,
      emptyEmail: false,
      emptyPassword: false,
      showErrorMessage: false,
      email: null,
      password: null,
      emailBlured: false,
      valid: false,
      submitted: false,
      error: null,
      validationErrors: {
        firstName: null,
        lastName: null,
        username: null,
        email: null,
        address: null,
        country: null,
        state: null,
        zip: null
      }
    }
  },

  methods: {
    gitKayit() {
      this.$router.push('/uye-ol')
    },
    selectUniversity(id, facultyId) {
      // this.university_id = opt.id
      // this.messageForm.university_id = opt.id
      let self = this
      axios
        .get(`/selected/faculties/${id}`)
        .then(response => {
          self.faculties = response.data
          response.data.forEach(data => {
            if (data.id === facultyId) {
              window.localStorage.setItem('faculty_name', data.name)
            }
          })
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    setUniversityName(id, facultyId) {
      let self = this
      axios
        .get('/selected/universities')
        .then(response => {
          response.data.forEach(data => {
            if (data.id === id) {
              window.localStorage.setItem('university_name', data.name)
              self.selectUniversity(id, facultyId)
            }
          })
          self.universities = response.data
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    validateForm() {
      var formId = 'validated-form'
      var nodes = document.querySelectorAll(`#${formId} :invalid`)
      var errorObjectName = 'validationErrors'
      var vm = this // current vue instance;

      Object.keys(this[errorObjectName]).forEach(key => {
        this[errorObjectName][key] = null
      })

      if (nodes.length > 0) {
        nodes.forEach(node => {
          this[errorObjectName][node.name] = node.validationMessage
          node.addEventListener('change', function(e) {
            vm.validateForm()
          })
        })

        return false
      } else {
        return true
      }
    },
    validate: function() {
      this.emailBlured = true
      if (this.validEmail(this.email)) {
        this.valid = true
      }
    },
    validEmail: function(email) {
      let re = /(.+)@(.+){2,}\.(.+){2,}/
      return re.test(email.toLowerCase())
    },
    validateEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(email).toLowerCase())
    },
    login() {
      this.falseEmail = false
      this.emptyPassword = false
      this.emptyEmail = false
      const verifiedMail = this.validateEmail(this.email)
      if (!this.password) {
        this.emptyPassword = true
      }
      if (!this.email) {
        this.emptyEmail = true
      } else if (this.email && !verifiedMail) {
        this.falseEmail = true
      }

      if (verifiedMail && this.password) {
        var self = this
        if (!this.valid) {
          // this.email = 'Mail giriniz'
          this.$refs.input1.value = 'Mail giriniz'
        }
        axios
          .post(`/user/login`, {
            email: this.email,
            password: this.password
          })
          .then(response => {
            if (response.status === 200 || response.status === 201) {
              // self.showSuccessMessage = true
              // self.commit(SET_USER_INFO, response.data.user)
              self.$store.commit(SET_USER_INFO, response.data.user)
              const data = { updateLogin: true, isLogin: 'true' }
              self.$store.commit(SET_USER_INFO, data)
              self.$store.commit(SET_TOKEN, response.data.token)
              axios.defaults.headers.common['Authorization'] =
                'Bearer ' + response.data.token
              self.$router.push('/')
              window.localStorage.setItem('type_id', response.data.user.type_id)
              window.localStorage.setItem(
                'first_name1',
                response.data.user.first_name
              )
              window.localStorage.setItem(
                'last_name1',
                response.data.user.last_name
              )
              window.localStorage.setItem(
                'username',
                response.data.user.first_name +
                  ' ' +
                  response.data.user.last_name
              )
              window.localStorage.setItem('isLogin', 'true')
              window.localStorage.setItem(
                'cache:dorm_logo',
                response.data.user.logo
              )
              window.localStorage.setItem('access_token', response.data.token)
              window.localStorage.setItem('mail1', response.data.user.email)
              window.localStorage.setItem('phone1', response.data.user.phone)
              window.localStorage.setItem('pwd', this.password)

              if (response.data.user.university_id) {
                window.localStorage.setItem(
                  'university_id1',
                  response.data.user.university_id
                )
              } else {
                window.localStorage.setItem('university_id1', '')
              }
              if (response.data.user.faculty_id) {
                window.localStorage.setItem(
                  'faculty_id1',
                  response.data.user.faculty_id
                )
              } else {
                window.localStorage.setItem('faculty_id1', '')
              }

              if (response.data.user.university_name) {
                window.localStorage.setItem(
                  'university_name1',
                  response.data.user.university_name
                )
              } else {
                window.localStorage.setItem('university_name1', '')
              }
              if (response.data.user.faculty_id) {
                window.localStorage.setItem(
                  'faculty_name1',
                  response.data.user.faculty_name
                )
              } else {
                window.localStorage.setItem('faculty_name1', '')
              }
            } else {
              this.showErrorMessage = true
            }
          })
          .catch(error => {
            if (error.response) {
              this.showErrorMessage = true
              // console.log('hata: ' + error.response);
            }
          })
      }
    }
  }
}
</script>

<style lang="scss">
@import '../assets/scss/components/login';

/* Show red borders when filled, but invalid */
input[data-state='invalid'] {
  border-color: hsl(0, 76%, 50%);
}

/* Show green borders when valid */
input[data-state='valid'] {
  border-color: hsl(120, 76%, 50%);
}

.mycursor1 {
  cursor: default;
  pointer-events: none;
}
</style>
